import React from "react";
import { bool, string } from "prop-types";
import styled from "styled-components";
import { motion } from "framer-motion";

import ProgressCircle from "./ProgressCircle";
import CheckMark from "./CheckMark";
import CitroenMark from "./CitroenMark";
import HomeMark from "@components/shared/Icons/HomeTDLogo.js";

import { prop } from "../../../../shared/utils";

const ProgressContainer = styled.aside`
  min-width: 3rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 1;
`;

const CircleContainer = styled.div`
  position: relative;
`;

const ProgressLine = styled(motion.div)`
  width: 2px;
  background-color: ${prop("progressBarColor")};
  height: 100%;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: -1;
`;

const ProgressBar = ({
  progressBarColor = "#000",
  isComplete,
  isInitialStep,
  isFinalStep,
  progressLineOnCompleteStep = true,
  isHomeTestDrive,
}) => {
  const circleSize = 35;
  const circleDelay = 0.3;
  const circleFillDuration = 0.3;
  const circleDrawDuration = 0.3;
  const checkMarkWidth = 19;
  const checkMarkHeight = 15;
  const checkMarkDelay = 0.6;
  const checkMarkDuration = 0.25;
  const progressLineDelay = 0.9;
  const progressLineDuration = 0.4;

  return (
    <ProgressContainer>
      {isHomeTestDrive ? (
        <CircleContainer>
          <HomeMark height="35px" width="35px" />
        </CircleContainer>
      ) : (
        <CircleContainer>
          <ProgressCircle
            progressBarColor={progressBarColor}
            isComplete={isComplete}
            size={circleSize}
            delay={circleDelay}
            fillDruation={circleFillDuration}
            drawDuration={circleDrawDuration}
          />
          {isInitialStep ? (
            <CitroenMark />
          ) : (
            <CheckMark
              width={checkMarkWidth}
              height={checkMarkHeight}
              isComplete={isComplete}
              delay={checkMarkDelay}
              duration={checkMarkDuration}
            />
          )}
        </CircleContainer>
      )}
      {!isFinalStep && (
        <ProgressLine
          progressBarColor={progressBarColor}
          initial={{ height: "0%" }}
          animate={{
            height: isComplete && progressLineOnCompleteStep ? "100%" : "0%",
          }}
          transition={{
            delay: progressLineDelay,
            duration: progressLineDuration,
          }}
        />
      )}
    </ProgressContainer>
  );
};
ProgressBar.propTypes = {
  isComplete: bool,
  isFinalStep: bool,
  isInitialStep: bool,
  progressBarColor: string,
  progressLineOnCompleteStep: bool,
  isHomeTestDrive: bool,
};

export default ProgressBar;
